<form [formGroup]="commonForm">
    <div class="inputprt">
        <input type="text" placeholder="Name on the card" formControlName="nameOnCard" (keyup)="apiService.restrictSpace($event)" (keypress)="apiService.restrictSpecialChar($event, true)"/>
        <mat-error *ngIf="commonForm.controls['nameOnCard'].touched && commonForm.controls['nameOnCard'].hasError('required')">
            This is required
        </mat-error>
        <mat-error *ngIf="commonForm.controls['nameOnCard'].touched && commonForm.controls['nameOnCard'].hasError('minlength')">
            Please enter a valid name.
        </mat-error>
    </div>
    <div class="inputprt">
        <input type="text" placeholder="Card Number" formControlName="cardNumber" [mask]="cardType === 'American Express' ? '0000 000000 00000' : '0000 0000 0000 0000'" (ngModelChange)="detectCardType($event)" />
        <span *ngIf="cardType && cardType === 'Visa'" class="cardlogo">
            <img src="https://cdn.elitehw.com/images/visa-card-logo.png" alt="visa_Logo">
          </span>
          <span *ngIf="cardType && cardType === 'Mastercard'" class="cardlogo mastercard">
            <img src="https://cdn.elitehw.com/images/master-card.png" alt="Master_card_logo">
          </span>
          <span *ngIf="cardType && cardType === 'American Express'" class="cardlogo">
            <img src="https://cdn.elitehw.com/images/American-Express.png" alt="American_express_logo">
          </span>
          <span *ngIf="cardType && cardType === 'Discover'" class="cardlogo">
            <img src="https://cdn.elitehw.com/images/discover.png" alt="Discover_logo">
          </span>
        <mat-error *ngIf="commonForm.controls['cardNumber'].touched && commonForm.controls['cardNumber'].hasError('required')">
            This is required
        </mat-error>
        <mat-error *ngIf="commonForm.controls['cardNumber'].touched && commonForm.controls['cardNumber'].hasError('mask')">
            Enter Valid Card Number
        </mat-error>
    </div>
    <div class="twopanel">
        <span class="expiration">
            <input type="text" [placeholder]="isFocused ? 'MM/YY' : 'Expiration Date'" formControlName="monthYear" mask="00/00" (focus)="isFocused = true" (blur)="isFocused = false" />
            <mat-error
              *ngIf="commonForm.controls['monthYear'].touched && commonForm.controls['monthYear'].hasError('required')">
              This is required
            </mat-error>
            <mat-error
              *ngIf="commonForm.controls['monthYear'].touched && commonForm.controls['monthYear'].hasError('mask') && !commonForm.controls['monthYear'].hasError('required')">
              Enter valid Expiry month and year.
            </mat-error>
            <mat-error
              *ngIf="!commonForm.controls['monthYear'].hasError('required') && commonForm.controls['monthYear'].touched && commonForm.controls['expiryMonth'].hasError('max') && !commonForm.controls['monthYear'].hasError('mask') && commonForm.controls['expiryYear'].valid">
              Enter Valid Expire Month.
            </mat-error>
            <mat-error
              *ngIf="!commonForm.controls['monthYear'].hasError('required')&& commonForm.controls['monthYear'].touched && commonForm.controls['expiryMonth'].hasError('min') && !commonForm.controls['monthYear'].hasError('mask')">
              Expiry Month value should be greater then 1.
            </mat-error>
            <mat-error
              *ngIf="!commonForm.controls['monthYear'].hasError('required') && commonForm.controls['monthYear'].touched && commonForm.controls['expiryYear'].hasError('min') && !commonForm.controls['monthYear'].hasError('mask') && commonForm.controls['expiryMonth'].valid">
              Enter Valid Expire Year.
            </mat-error>
            <mat-error
            *ngIf="!commonForm.controls['monthYear'].hasError('required') && commonForm.controls['monthYear'].touched && commonForm.controls['expiryMonth'].hasError('max') && !commonForm.controls['monthYear'].hasError('mask') && !commonForm.controls['monthYear'].hasError('required') && commonForm.controls['monthYear'].touched && commonForm.controls['expiryYear'].hasError('min') && !commonForm.controls['monthYear'].hasError('mask')">
           Enter valid expire month and year.
          </mat-error>
        </span>
        <span class="short">
            <input type="text" placeholder="CVV Code" formControlName="cvv" [mask]="cardType == 'American Express'? '0000' : '000'" />
            <mat-error *ngIf="commonForm.controls['cvv'].touched && commonForm.controls['cvv'].hasError('required')">
                This is required
            </mat-error>
            <mat-error *ngIf="commonForm.controls['cvv'].touched && commonForm.controls['cvv'].hasError('mask')">
                Enter valid cvv code.
            </mat-error>
        </span>
    </div>
    <div class="inputprt" *ngIf="showTransactionNumber">
  
      <input
          type="text"
          placeholder="Transaction Number"
          formControlName="transactionNumber"
        />
      <mat-error *ngIf="commonForm?.controls?.transactionNumber?.touched && commonForm?.controls?.transactionNumber?.hasError('required')">
          This is required
      </mat-error>
  </div>
</form>
